import { messagePath } from "@travily/routes";
import { formatConversationTimestamp } from "@ui/lib/format-message-time";
import { Link } from "@ui/primitives/Link";
import { AccountAvatar } from "@/components/AccountAvatar/AccountAvatar";
import type { ConversationParticipation } from "../ConversationListView";

interface ConversationListItemProps {
  conversation: ConversationParticipation;
  isActive: boolean;
}

export function ConversationListItem({ conversation, isActive }: ConversationListItemProps) {
  const { other_account, unread } = conversation;
  const { last_message_body, last_message_at, last_message_sender_name } = conversation.conversation;

  const previewText = last_message_body
    ? last_message_sender_name
      ? `${last_message_sender_name}: ${last_message_body}`
      : last_message_body
    : null;

  return (
    <Link
      className={`relative flex w-full items-start gap-3 rounded-2xl px-3 py-2.5 text-left no-underline outline-none focus-visible:ring-2 focus-visible:ring-neutral-400 ${
        isActive ? "bg-neutral-50" : "hover:bg-neutral-25"
      }`}
      href={messagePath(conversation.conversation.sqid)}
    >
      <AccountAvatar account={other_account} className="shrink-0" shape="circle" size="44" />
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="truncate font-semibold text-base text-neutral-900">{other_account.display_name}</span>
        {previewText && (
          <span className={`truncate text-sm ${unread ? "font-semibold text-neutral-900" : "text-neutral-600"}`}>
            {previewText}
          </span>
        )}
      </div>
      {/* Timestamp and unread marker share one trailing column: when the row last spoke, and
          whether it still wants you. */}
      <div className="flex shrink-0 flex-col items-end gap-1.5 pt-0.5">
        {last_message_at && (
          <span className="whitespace-nowrap text-neutral-400 text-xs">
            {formatConversationTimestamp(last_message_at)}
          </span>
        )}
        {unread && <span className="size-2 rounded-full bg-red-400" />}
      </div>
    </Link>
  );
}
